import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import rOyakGmCiroBazli from '../../models/rOyakGmCiroBazli';

export default class OyakGmCiroBazliApi extends ApiBase<pList, rValue<rOyakGmCiroBazli>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakGmCiroBazli',
      }),
      options
    );
  }
}
